"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Switch = _interopRequireDefault(require("./Switch"));

var ExportSwitch = _Switch.default;
ExportSwitch.Sizes = ['sm', 'md', 'lg'];
var _default = _Switch.default;
exports.default = _default;